import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from "@/components/primitives";
import { AlertTriangle } from "lucide-react";
import type { ContributingFactor } from "../types";

interface ContributingFactorsCardProps {
	factors: ContributingFactor[];
}

export function ContributingFactorsCard({
	factors,
}: ContributingFactorsCardProps) {
	if (factors.length === 0) {
		return null;
	}

	return (
		<Card className="border-2 shadow-xl bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm print-borderless">
			<CardHeader className="pb-4 border-b bg-gradient-to-r from-blue-50/50 to-indigo-50/50 dark:from-blue-950/20 dark:to-indigo-950/20">
				<div className="flex items-center gap-3">
					<div className="p-2 rounded-lg bg-gradient-to-br from-red-500 to-orange-600">
						<AlertTriangle className="h-5 w-5 text-white" />
					</div>
					<div>
						<CardTitle className="text-xl sm:text-2xl font-semibold">
							Contributing Factors ({factors.length})
						</CardTitle>
					</div>
				</div>
			</CardHeader>
			<CardContent className="pt-6">
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
					{factors.map((factor) => (
						<div
							key={factor.id}
							className="border-2 rounded-lg p-4 bg-red-50/50 dark:bg-red-900/10 border-red-200 dark:border-red-800 shadow-md"
						>
							<h4 className="font-semibold text-foreground mb-2">
								{factor.title}
							</h4>
							<p className="text-sm text-muted-foreground leading-relaxed">
								{factor.description}
							</p>
						</div>
					))}
				</div>
			</CardContent>
		</Card>
	);
}
